export const DOWNLOAD_CATALOG_STEPS = ['Descargar plantilla', 'Subir plantilla', 'Resumen'];

export const PRODUCT_TYPE_OPTIONS = [
  {
    id: 1,
    title: 'Todos los productos',
    description: 'Se descargarán todos los productos. prendidos y apagados'
  },
  {
    id: 2,
    title: 'Solo productos prendidos',
    description: 'Se descargarán todos los productos disponibles en tienda'
  },
  {
    id: 3,
    title: 'Descargar plantilla vacía',
    description: 'Descarga la plantilla vacia para actualizar que productos mostrar en la tienda'
  }
];
